import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as DownArrow } from './img/diagram-arrow.svg';
import './CultureStackExplained.css';

export default class CultureStackExplained extends Component {
  static propTypes = {
    header: PropTypes.string,
    lines: PropTypes.array,
  }

  render() {
    const { header, lines } = this.props;

    let cssSubSectionOverride = '';
    if (header.toLowerCase().search('purpose') !== -1) {
      cssSubSectionOverride = 'Purpose';
    } else if (header.toLowerCase().search('actions') !== -1) {
      cssSubSectionOverride = 'Actions';
    } else if (header.toLowerCase().search('skills') !== -1) {
      cssSubSectionOverride = 'Skills';
    }

    return (
      <section className={`culture-stack-explained ${cssSubSectionOverride}`}>
        <h3 dangerouslySetInnerHTML={{ __html: header }} />
        <h4 dangerouslySetInnerHTML={{ __html: lines[0] }} />
        <DownArrow className="down-arrow" />
        <p dangerouslySetInnerHTML={{ __html: lines[1] }} />
      </section>
    );
  }
}
